export function servicesFunc() {
	let servicesTop = $("#servicesTop").length;

	if(servicesTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

		subNavHeightFunc();

		subNavAccordionFuc();

		subNavScrollFunc();

		function subNavHeightFunc(){
			let subNavHeight = $(".subNav");
			let headerHeight = $("#header").outerHeight();
			subNavHeight.css("top" , `${headerHeight}px`);
			
			let setTimer = false;
			$(window).on('resize', function () {
				if (setTimer !== false) {
					clearTimeout(setTimer);
				  }
				  setTimer = setTimeout(() => {
					subNavHeightFunc();
				  }, 200);
			});
			
		}
		
		function subNavAccordionFuc(){
			const servicesSubNavAccordionBtn = $('#servicesSubNav .accordionBtn');
			const servicesSubNav = $('#servicesSubNavList a');
			let resizecheck = $('#responsibleCheck').width();
			let resizecheck2 = 0;
		  
			$(window).on('load resize', function () {
			  resizecheck = $('#responsibleCheck').width();
			  subNavAccordionMenuStart();
			  subNavCloseFunc();
			});
	
			//スマホのみサブナビをクリックでクローズさせる
			function subNavCloseFunc() {
				servicesSubNav.on('click', subNavClickHandler);
			}
			function subNavClickHandler() {
				servicesSubNavAccordionBtn.next('dd').slideUp(500);
				servicesSubNavAccordionBtn.removeClass('isOpen');
			}
			subNavCloseFunc()
	
			servicesSubNavAccordionBtn.on('click', function () {
				if ($(this).hasClass('isOpen')) {
					$(this).next('dd').slideUp(500);
					$(this).removeClass('isOpen');
				} else {
					servicesSubNavAccordionBtn.next('dd').slideUp(500);
					servicesSubNavAccordionBtn.removeClass('isOpen');
					$(this).next('dd').slideDown(500);
					$(this).addClass('isOpen');
				}
			}); 
			
			var subNavAccordionMenuStart = function () {
				let resizecheck = $('#responsibleCheck').width();
				servicesSubNavAccordionBtn.next('dd').css('display', 'none');
				resizecheck2 = 2;
			}
			subNavAccordionMenuStart();
		}

		function subNavScrollFunc(){
			// 今回の交差を監視する要素
			const boxes = document.querySelectorAll(".serviceContents");

			const options = {
				root: null,
				rootMargin: "-50% 0px -50%",
				threshold: 0
			};
			const observer = new IntersectionObserver(doWhenIntersect, options);
			boxes.forEach(box => {
				observer.observe(box);
			});

			/**
			 * 交差したときに呼び出す関数
			 * @param entries
			 */
			function doWhenIntersect(entries) {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						activateIndex(entry.target);
					}
				});
			}
			/**
			 * 目次を変える関数
			 * @param element
			 */
			function activateIndex(element) {
				const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
				if (currentActiveIndex !== null) {
					currentActiveIndex.classList.remove("active");
				}
				const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
				newActiveIndex.classList.add("active");

				const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent
				$("#navCurrent").text(currentTxt).css({"color":"#004092"})
			}
		}

		function serviceCommonAnimeFunc() {
      $('.serviceContents').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.serviceContentsTit').hasClass('isShow')) {
							$(this).find('.serviceContentsTit').addClass('isShow');
              $(this).find('.serviceContentsLead').addClass('isShow');
            }
            return wait(200)
          })
          .then(() => {
              if (!$(this).find('.imgBox').hasClass('isShow')) {
                $(this).find('.imgBox').addClass('isShow');
                $(this).find('.serviceContentsList').addClass('isShow');
                $(this).find('.serviceContentsTxt').addClass('isShow');
              }
              return wait(500)
          })
        }
      });
    }serviceCommonAnimeFunc();

		$(window).on('load scroll', function () {
      serviceCommonAnimeFunc();

			let navChangeHeight = $(".mainview").outerHeight() / 3;
			var subNavCurrent = $("#servicesSubNavList .pageLinkList")
			var scroll = $(window).scrollTop();

			if(scroll < navChangeHeight){
				$("#navCurrent").text("Service Lineup").css({"color":"#121212"})
				if (subNavCurrent.hasClass('active')) {
					subNavCurrent.removeClass("active")
				}
			}
		});
	}
}